
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","data-name":"Layer 1","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.94 6.59l-.88 4.39a5.017 5.017 0 01-4.9 4.02H6.73c.42 1.18 1.53 2 2.83 2H19c.55 0 1 .45 1 1s-.45 1-1 1H9.56c-2.53 0-4.67-1.9-4.97-4.42L3.21 2.88c-.06-.5-.49-.88-.99-.88H1c-.55 0-1-.45-1-1s.45-1 1-1h1.22c1.52 0 2.8 1.14 2.98 2.65l.04.35H9c.55 0 1 .45 1 1s-.45 1-1 1H5.48l.94 8h11.74c1.42 0 2.66-1.01 2.94-2.41l.88-4.39c.06-.29-.02-.6-.21-.83C21.58 5.14 21.3 5 21 5h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.9 0 1.75.4 2.32 1.1s.8 1.61.62 2.49zM7 20c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM9.27 7.25c-.38.4-.35 1.04.05 1.41l1.56 1.46c.59.59 1.36.88 2.13.88s1.52-.29 2.09-.86l1.59-1.48a.997.997 0 10-1.36-1.46l-1.32 1.23V1c0-.55-.45-1-1-1s-1 .45-1 1v7.43L10.69 7.2a.996.996 0 00-1.41.05z"}})])
          )
        }
      }
    